export default __webpack_public_path__ + "static/media/ROTAFOLIO_ASPROS_EN.6f328e6a.pdf";